import { getUrlKey,isMobile } from "@/util/util";
import guide from '../data/guide';

export default {
    data() {
        return {
            comment: '',
            is_reply: false,
            status_comment: 0,
            comment_list: [],
            info: {},
            news: {},
            p: 1,
            is_login: false,
            id: 0,
            guide,
            download_img: ''
        }
    },

    watch:{
        '$route':'getId'
    },

    created() {
        this.is_login = this.$isLogin();
        this.id = getUrlKey('id',location.href);
        if(isMobile()) {
            location.href = this.$link + '/news/detail?id=' + this.id
        }
        this.getRightInfo();
        this.addCount();
        this.getDownloadInfo();
    },

    methods: {
        getId() {
            this.status_comment = 0;
            this.id = getUrlKey('id',location.href);
            this.getInfo()
        },

        getDownloadInfo() {
            this.$post('api.php/Home/down').then(res => {
                if(res.status === 1) {
                    this.download_img = res.data.blend || '';
                }
            })
        },

        openStore() {
           // window.open('https://apps.apple.com/cn/app/id1409553534')
        },

        openIndex() {
            this.$router.push({
                name: 'index'
            })
        },

        // 增加阅读量
        addCount() {
            this.$post('api.php/Index/setClickCount',{
                id: this.id,
                type: 1
            }).then(res => {
                if (res.status === 1) {
                    this.getInfo()
                }
            })
        },

        openLogin() {
            this.$parent.$children[0].openLoginPop();
        },


        // 获取资讯详情
        getInfo() {
            // if(this.status_comment === 2) {
            //     return;
            // }
            this.$post(
                'api.php/Index/articleDetails',
                {
                    article_id: this.id,
                    user_id: this.$getUserinfo().id || '',
                    p: this.p
                }
            ).then(res => {
                if(res.status === 1) {

                    let data = res.data || {};

                    console.log(1,Object.keys(data))

                    if(data.length <= 0 || Object.keys(data).length <= 0) {

                        this.$message.error('该文章已被删除！');

                        setTimeout(() => {
                            this.$router.replace({
                                name: 'index'
                            })
                        },2000);

                    }else {
                        this.news = res.data || {};
                        document.title = (res.data.name || '') + '-' + (res.data.category || '') + '- 文娱中国';
                        if(this.p === 1) {
                            this.comment_list = this.news.comment_list || [];
                        }else {
                            let arr = this.news.comment_list || []

                            this.comment_list = this.comment_list.concat(arr);
                        }

                        if(this.comment_list.length === this.news.comment_count) {
                            this.status_comment = 2;
                        }else if(this.news.comment_count === 0){
                            this.status_comment = 0;
                        }else {
                            this.status_comment = 1;
                        }
                    }

                }
            })
        },

        initCommentList() {
            this.p = 1;
            this.status_comment = 0;
            this.comment_list = [];
            this.getInfo();
        },

        loadInfo() {
            this.p ++;
            this.getInfo();
        },

        // 获取右侧列表信息
        getRightInfo() {
            this.$post('api.php/Home/articleRight',{
                article_id: this.id,
            }).then(res => {
                if(res.status === 1) {
                    this.info = res.data || {};
                }
            })
        }
    }
}
